<div class="bs3-login-shell">
  <div class="bs3-login-card">
    <div class="bs3-brand-header">
      <img
        src="assets/images/bella-icon-36.svg"
        alt="Bella Studio"
        width="44"
        height="44"
        style="width:44px;height:44px;max-width:44px;max-height:44px;border-radius:12px;display:block;flex-shrink:0;"
      />
      <div class="bs3-brand-titles">
        <div class="bs3-brand-row">
          <h1 class="bs3-brand-name">Bella Studio</h1>
          <span class="bs3-version-pill">v3.0</span>
        </div>
      </div>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="bs3-form">
      <div class="bs3-field">
        <label class="bs3-label">Studio Email</label>
        <div class="bs3-input-wrap">
          <mat-icon class="bs3-input-icon">email</mat-icon>
          <input
            type="email"
            class="bs3-input"
            formControlName="email"
            placeholder="Enter your email"
            autocomplete="email"
          />
        </div>
      </div>

      <div class="bs3-field">
        <label class="bs3-label">Password</label>
        <div class="bs3-input-wrap">
          <mat-icon class="bs3-input-icon">lock</mat-icon>
          <input
            class="bs3-input"
            formControlName="password"
            [type]="hidePassword ? 'password' : 'text'"
            placeholder="Enter password"
            autocomplete="current-password"
          />
          <button type="button" class="bs3-eye-btn" (click)="hidePassword = !hidePassword">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </div>
      </div>

      <button type="submit" class="bs3-submit-btn" [disabled]="loginForm.invalid || isLoading">
        <span *ngIf="!isLoading">Sign In to Studio</span>
        <span *ngIf="isLoading">Signing in...</span>
      </button>
    </form>

    <div class="bs3-footer-links">
      <span>BellaSpeak Limited · Hong Kong SAR</span>
      <span>Locked Mint &amp; Night v2.0</span>
    </div>
  </div>
</div>
